/**
 * Gestione delle finestre modali.
 * Ogni elemento con attributo data-modal, o link con href
 * con valore "#modal-*", sarà gestito come attivazione
 * del meccanismo di visualizzazione delle modali.
 * La modale mostrata sarà quella dell'attributo data-modal
 * oppure quella nel valore di href. Ad esempio:
 *
 * <button type="button" data-modal="login">Login</button>
 * <a href="#modal-login">Login</a>
 *
 * Entrambi faranno scattare l'apertura della modale
 * con nome "login". Se il nome specificato è "close",
 * il sistema lo riconoscerà e funzionerà da meccanismo
 * di chiusura di qualsiasi modale aperta.
 */

export default $ => {
    
    let ajaxModal = null;
        
    const openModal = target => {
        closeModal();

        if (target !== 'close') {
            $('body').addClass('uIsModalOpen');
            $('.cModals').addClass('uIsModalOpen');
            $(`#modal-${target}`).addClass('uIsOpen');
        }
    };

    const openModalAjax = (url, target) => {
        // Inizializza il container per le modali ajax
        const $container = $('.cModals');
        $.ajax(url, {
            dataType: 'html',
            success: function(content) {
                const $content = $(content);
                $content.appendTo($container);
                openModal(target);
                
                $content.addClass('cModal-Ajax');
                ajaxModal = {url: url, target: target};
            }
        });
    };
    
    const reloadModalAjax = () => {
        if (ajaxModal) {
            openModalAjax(ajaxModal.url, ajaxModal.target);
        }
    };

    const closeModal = () => {
        $('.cModal.uIsOpen').removeClass('uIsOpen');
        $('body').removeClass('uIsModalOpen');
        $('.cModals').removeClass('uIsModalOpen');
        $('.cModal-Ajax').remove();
        ajaxModal = null;
    };

    $('body').on('click', '[href^="#modal-"], [data-modal]', function (event) {
        event.preventDefault();

        const self = $(this);

        // Recupera il nome della modale da aprire
        // a seconda che l'elemento abbia l'attributo
        // href (ovvero è un link) oppure l'attributo
        // data-modal (quindi qualsiasi elemento).
        const target = self.attr('href')
                ? self.attr('href').replace('#modal-', '')
                : self.data('modal');

        openModal(target);
        return false;
    });

    $('a[data-modal-ajax]').click(function (event) {
        event.preventDefault();

        const self = $(this);
        const url = self.attr('href');   // Url
        const target = self.data('modal-ajax');  // Name of the modal

        openModalAjax(url, target);

        return false;
    });

    // Intercetta i click sullo strato di overlay,
    // in modo da poterlo utilizzare per chiudere le modali attive.
    $('.cModals').click(function (e) {
        if (e.target == this) {
            closeModal();
        }
    });

    // window.modalOnLoad è utilizzato per gestire eventuali modali
    // che devono aprirsi immediatamente dopo il caricamento della pagina.
    if (window.modalOnLoad) {
        openModal(window.modalOnLoad);
    }

    // window.openModal e window.closeModal sono usate per controllare le modali
    // via javascript
    window.openModal = openModal;
    window.reloadModalAjax = reloadModalAjax;
    window.closeModal = closeModal;
};



// WEBPACK FOOTER //
// ./assets/js/component/modal.js